var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.messages),function(message){return _c('BaseMessage',{key:message.id,attrs:{"data":message}})}),(_vm.messages.length === 0)?_c('h3',{staticClass:"black--text"},[_vm._v("暂无消息，刷新试试！")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }